import { render, staticRenderFns } from "./regionalManagement.vue?vue&type=template&id=ce7642b2&scoped=true"
import script from "./regionalManagement.vue?vue&type=script&lang=js"
export * from "./regionalManagement.vue?vue&type=script&lang=js"
import style0 from "./regionalManagement.vue?vue&type=style&index=0&id=ce7642b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce7642b2",
  null
  
)

export default component.exports